import { BannerSectionModel } from '@/models/banner-section.model';
import { BannerModel } from '@/models/banner.model';
import { ValidatorResult } from '@onrunning/backstage-models';
import { CrudService } from './crud.service';

export class BannersService {
  private crudService: CrudService<BannerModel>;

  constructor() {
    this.crudService = new CrudService<BannerModel>('banners');
  }

  public async getBannerSections(): Promise<ValidatorResult<BannerSectionModel[]>> {
    return await this.crudService.do('get', 'sections', undefined, undefined, 'silent');
  }

  /**
   * @deprecated This method is deprecated and will be removed in a future version.
   * Use `getBannersByAccountId` instead.
   */
  public async getBanners(sectionId: string, locale: string): Promise<ValidatorResult<BannerModel[]>> {
    return await this.crudService.do('get', `${sectionId}/${locale}`, undefined, undefined, 'silent');
  }

  public async getBannersByAccountId(sectionId: string, accountId: string): Promise<ValidatorResult<BannerModel[]>> {
    const queryParams = new URLSearchParams();
    queryParams.set('accountId', accountId);

    return await this.crudService.do('get', `${sectionId}?${queryParams}`, undefined, undefined, 'silent');
  }
}
